import Utils from "../misc/Utils";
import Alert from "./Alert";
import Modals from "./Modals";

class Media {
    static onMediaRate($element) {
        let rate_el = $element;
        let	other_rate_el= false;
        let other_rate_voted = false;
        let	media_id = jQuery(rate_el).attr('data-content') || "";
        let	value = jQuery(rate_el).attr('data-value') || "";
        let	ajax_hash = jQuery(rate_el).attr('data-ajax-hash') || "";
        let	intent = "save";

        if(!media_id || !value || !ajax_hash) {
            if(rate_el.parents('.stories-wrapper').length > 0) {
                return Alert.showGeneralAlert("You must be logged in to rate");
            }
            return Modals.showModalTemplate('login-modal', function ($modal) {
                $modal.on('click', '[data-close-modal]', function () {
                    Utils.animateDockIcons(jQuery('.mobile-dock-nav').find('.was-active'));
                });
            });
        }

        // find the other rating element
        if("up" === value) {
            other_rate_el = jQuery("#media_rate__"+ media_id +"__down");
        } else {
            other_rate_el = jQuery("#media_rate__"+ media_id +"__up");
        }

        // remove rating from other rating element (if any)
        other_rate_voted = jQuery(other_rate_el).hasClass("voted-for");
        jQuery(other_rate_el).removeClass("voted-for");

        // make the change immediate, and change intent if user has already voted
        if(jQuery(rate_el).hasClass("voted-for")) {
            intent = "remove";
            jQuery(rate_el).removeClass("voted-for");
        } else {
            jQuery(rate_el).addClass("voted-for");
        }

        Utils.commit_ajax_action('rate_content', {
            'id': media_id,
            'value': value,
            'intent': intent,
            'hash': ajax_hash
        }, function(data) {
            if(data && data.status && ("error" === data.status)) {
                if(data.message) {
                    Alert.showGeneralAlert(data.message);
                } else {
                    Alert.showGeneralAlert("Error rating comment, try again");
                }
                // revert vote
                if("remove" === intent) {
                    jQuery(rate_el).addClass("voted-for");
                } else {
                    jQuery(rate_el).removeClass("voted-for");
                    if(other_rate_voted) {
                        jQuery(other_rate_el).addClass("voted-for");
                    }
                }
                return;
            }
            if(data.cargo && data.cargo.hasOwnProperty("votes_up")) {
                jQuery("#media_rate__"+ media_id +"__up_count").text(data.cargo.votes_up);
            }
            if(data.cargo && data.cargo.hasOwnProperty("votes_down")) {
                jQuery("#media_rate__"+ media_id +"__down_count").text(data.cargo.votes_down);
            }
        }, function(data) {
            Alert.showGeneralAlert("Something went wrong, try again");
            // revert vote
            if("remove" === intent) {
                jQuery(rate_el).addClass("voted-for");
            } else {
                jQuery(rate_el).removeClass("voted-for");
                if(other_rate_voted) {
                    jQuery(other_rate_el).addClass("voted-for");
                }
            }
        });
    }
    static onMediaFavorite($element) {
        let $el = $element;
        let media_id = $el.attr('data-content') || "";
        let intent = $el.attr('data-intent') || "save";
        let ajax_hash = $el.attr('data-ajax-hash') || "";
        let remove_selector = $el.attr('data-remove-selector') || false;
        let fav_el, unfav_el;
        let remove_el = false;

        if(!media_id || (("save" !== intent) && ("remove" !== intent)) || !ajax_hash) {
            if($el.parents('.stories-wrapper').length > 0) {
                return Alert.showGeneralAlert("You must be logged in to save to favorites");
            }
            return Modals.showModalTemplate('login-modal', function ($modal) {
                $modal.on('click', '[data-close-modal]', function () {
                    Utils.animateDockIcons(jQuery('.mobile-dock-nav').find('.was-active'));
                });
            });
        }

        fav_el = jQuery("#media_fav__"+ media_id);
        unfav_el = jQuery("#media_unfav__"+ media_id);
        if(remove_selector) {
            remove_el = jQuery(remove_selector);
        }
        // make the change immediate, and change intent if user has already voted
        if("save" === intent) {
            jQuery(fav_el).removeClass("active");
            jQuery(unfav_el).addClass("active voted-for");
        } else {
            jQuery(unfav_el).removeClass("active voted-for");
            jQuery(fav_el).addClass("active");
        }
        Utils.commit_ajax_action('favorite_content', {
            'id': media_id,
            'intent': intent,
            'hash': ajax_hash
        }, function(data) {
            if(data && data.status && ("error" === data.status)) {
                if(data.message) {
                    Alert.showGeneralAlert(data.message);
                } else {
                    Alert.showGeneralAlert("Error saving, try again");
                }
                // revert vote
                if("save" === intent) {
                    jQuery(unfav_el).removeClass("active voted-for");
                    jQuery(fav_el).addClass("active");
                } else {
                    jQuery(fav_el).removeClass("active");
                    jQuery(unfav_el).addClass("active voted-for");
                }
                return;
            }
            // optional - remove remove_el on success (if set)
            if((false !== remove_el) && jQuery(remove_el).length) {
                jQuery(remove_el).empty().remove();
            }
        }, function(data) {
            Alert.showGeneralAlert("Something went wrong, try again");
            // revert vote
            if("save" === intent) {
                jQuery(unfav_el).removeClass("active voted-for");
                jQuery(fav_el).addClass("active");
            } else {
                jQuery(fav_el).removeClass("active");
                jQuery(unfav_el).addClass("active voted-for");
            }
        });
    }
    
    static initEvents() {
        jQuery(document.body)
            .on('click', ".save_media_rate", function(evt) {
                evt.preventDefault();
                Media.onMediaRate(jQuery(this));
            })
            .on('click', ".save_media_favorite", function(evt) {
                evt.preventDefault();
                Media.onMediaFavorite(jQuery(this));
            });
    }
    static initModule() {
        Media.initEvents();
    }
}

export default Media;